<template>
  <select-with-buttons :options="options"
                       @click="propagateClick"></select-with-buttons>
</template>

<script>
import SelectWithButtons from '../lib/SelectWithButtons';

export default {
  name: 'SelectDouble',
  components: {SelectWithButtons},
  props: {
    showNt: {type: Boolean}
  },
  computed: {
    options() {
      return [
        {value: 0, text: '-', class: ['special', 'pass']},
        {value: 1, text: 'X', class: ['special', 'double']},
        {value: 2, text: 'XX', class: ['special', 'redouble']},
      ];
    },
  },
  methods: {
    propagateClick(clicked) {
      this.$emit('click', clicked);
    }
  }
};
</script>

<style scoped>
>>> .special {
  color: white;
  border: initial !important;
}
>>> .pass {
  background-color: green;
}
>>> .double {
  background-color: red;
}
>>> .redouble {
  background-color: #1d4ed8;
}
</style>